export function getEmailsFromPeoplePicker(str) {
  const userArray = JSON.tryParse(str, []);
  let names = [];
  for (const user of userArray) {
    names.push(user.email);
  }
  return names.join(", ");
}
